module.exports = __webpack_public_path__ + "img/linkedin.06f1322.svg";